export default {
	"pages": {
		"root": {
			"name": "root",
			"children": [
				"68f7854bd788530023e19e9a",
				"68f7854bd788530023e19e9e"
			],
			"id": "root",
			"pageUrl": "root"
		},
		"68f7854bd788530023e19e9a": {
			"id": "68f7854bd788530023e19e9a",
			"name": "404",
			"pageUrl": "404"
		},
		"68f7854bd788530023e19e9e": {
			"id": "68f7854bd788530023e19e9e",
			"name": "index",
			"pageUrl": "index",
			"seo": {
				"og:description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference.",
				"title": "Home | Website Example",
				"og:title": "Home | Website Example",
				"og:image": "https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z",
				"description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."
			}
		}
	},
	"mode": "production",
	"projectType": "create-react-app",
	"site": {
		"styles": {},
		"seo": {
			"title": "DayFive",
			"description": "Tame your books with DayFive",
			"customSitemapDomain": "https://dayfive.eu",
			"favicon_32px": "https://uploads.quarkly.io/68f7854bd788530023e19e81/images/balllogo.png?v=2025-10-25T15:24:36.353Z",
			"sitemapFileType": "autogenerated",
			"favicon_apple_152px": "https://uploads.quarkly.io/68f7854bd788530023e19e81/images/balllogo.png?v=2025-10-25T15:24:36.353Z",
			"favicon_win10_270px": "https://uploads.quarkly.io/68f7854bd788530023e19e81/images/balllogo.png?v=2025-10-25T15:24:36.353Z"
		}
	}
}